import { TicketReplyInterface } from "../common/interfaces";
import api from "./api";

export async function listTicketReplies(
  ticketId: number
): Promise<TicketReplyInterface[]> {
  const { data } = await api.get(`/ticket/${ticketId}/replies`);
  return data;
}

export async function createTicketReply(
  ticketId: number,
  message: string
): Promise<TicketReplyInterface> {
  const { data } = await api.post(`/ticket/${ticketId}/replies`, { message });
  return data;
}

export async function updateTicketReply(
  ticketId: number,
  replyId: number,
  message: string
): Promise<TicketReplyInterface> {
  const { data } = await api.patch(
    `/ticket/${ticketId}/replies/${replyId}`,
    { message }
  );
  return data;
}

export async function deleteTicketReply(
  ticketId: number,
  replyId: number
): Promise<void> {
  await api.delete(`/ticket/${ticketId}/replies/${replyId}`);
}
